const isValidZipCode = (sZip) => /^\d{5}(-\d{4})?$/.test(sZip);

export default isValidZipCode;
